<cx-storefront></cx-storefront>
<app-product-schema-component></app-product-schema-component>
<app-chat-widget></app-chat-widget>
